import { Photo } from 'Compass/profile-lab/types';

export const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  return date.toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

export const formatCoords = (latitude: number | null | undefined, longitude: number | null | undefined): string => {
  if (latitude == null || longitude == null || (latitude === -180 && longitude === -180)) {
    return 'Unknown location';
  }
  return `[${latitude.toFixed(2)},${longitude.toFixed(2)}]`;
};

export const extractDateParts = (isoString: string): { year: number; month: number; day: number } => {
  if (!isoString) {
    console.error('extractDateParts received empty string');
    return { year: 2000, month: 1, day: 1 };
  }

  const datePart = isoString.split('T')[0];
  if (!datePart) {
    console.error('extractDateParts: no date part found in', isoString);
    return { year: 2000, month: 1, day: 1 };
  }

  const parts = datePart.split('-');
  if (parts.length < 3) {
    console.error('extractDateParts: invalid date format', isoString);
    return { year: 2000, month: 1, day: 1 };
  }

  return {
    year: parseInt(parts[0], 10),
    month: parseInt(parts[1], 10),
    day: parseInt(parts[2], 10)
  };
};

export const attachPhotoStatus = (
  photos: Photo[],
  selectedSet: Set<number>,
  growSet: Set<number>
): Photo[] => {
  return photos.map((photo) => ({
    ...photo,
    status:
      selectedSet.has(photo.photo_lid) ? ('selected' as const) :
      growSet.has(photo.photo_lid) ? ('grow' as const) :
      ('none' as const),
  }));
};

export const fisherYatesShuffle = <T>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const getSelectionColors = (growCount: number, selectedCount: number, totalCount: number): { backgroundColor: string; color: string } => {
  if (totalCount === 0) return { backgroundColor: '#f7fafc', color: '#1a202c' };

  const combinedRatio = (growCount + selectedCount) / totalCount;
  const baseR = 255, baseG = 255, baseB = 255;

  let targetR, targetG, targetB;
  if (growCount > 0) {
    targetR = 16; targetG = 185; targetB = 129;
  } else {
    targetR = 147; targetG = 51; targetB = 234;
  }

  const bgR = Math.round(baseR + (targetR - baseR) * combinedRatio);
  const bgG = Math.round(baseG + (targetG - baseG) * combinedRatio);
  const bgB = Math.round(baseB + (targetB - baseB) * combinedRatio);

  const textColor = combinedRatio > 0.5 ? '#ffffff' : '#1a202c';

  return {
    backgroundColor: `rgb(${bgR}, ${bgG}, ${bgB})`,
    color: textColor
  };
};
